import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// NOTE: React.StrictMode intentionally double-mounts components in development,
// which conflicts with react-leaflet's DOM-level map initialization (throws
// "Map container is already initialized"). StrictMode is dev-only anyway —
// production builds don't double-mount, so this doesn't affect production.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
